import { storyblokEditable } from "@storyblok/react";
import ChartCell from "./ChartCell";

const ChartRow = ({ blok, rowIndex, columnCount }) => {
  const isStriped = rowIndex % 2 === 1;

  const cells = blok.cells || [];
  const missingCells = Math.max(0, columnCount - cells.length);

  return (
    <tr
      {...storyblokEditable(blok)}
      className={isStriped ? "bg-[#E3E3E3]" : "bg-white"}
    >
      {/* Left label cell */}
      <th
        scope="row"
        className="px-6 py-4 text-left align-top text-[16px] font-normal"
      >
        {blok.label}
      </th>

      {/* Data cells */}
      {cells.map((cellBlok) => (
        <ChartCell key={cellBlok._uid} blok={cellBlok} />
      ))}

      {/* Auto-filler empty cells that includes right spacer if BB content editors chose to enable it. I need to test that Boolean again to see if it's even needed anymore */}
      {Array.from({ length: missingCells }).map((_, idx) => (
        <td key={`empty-${idx}`} className="px-6 py-4" />
      ))}
    </tr>
  );
};

export default ChartRow;
